var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNeon = function SvgNeon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 57"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "neon_svg__a",
    x2: 1,
    gradientTransform: "matrix(-50.032 -57.652 62.466 -54.21 57.588 57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2ef51c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ef51c",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "neon_svg__b",
    x2: 1,
    gradientTransform: "matrix(-34.011 -13.404 13.812 -35.046 57.461 56.966)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 0
  })))), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 9.8C0 4.4 4.4 0 9.9 0h37.7c5.4 0 9.9 4.4 9.9 9.8v31.8c0 5.6-7.2 8-10.7 3.6L36 31.3v16.9c0 4.8-4 8.8-9 8.8H9.9C4.4 57 0 52.6 0 47.2zm9.9-2c-1.1 0-2 .9-2 2v37.3c0 1.1.9 2 2 2h17.4c.6 0 .7-.5.7-1V25.6c0-5.7 7.2-8.1 10.7-3.7l10.8 13.9v-26c0-1.1.1-2-1-2z",
    style: {
      fill: "#32c0ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 9.8C0 4.4 4.4 0 9.9 0h37.7c5.4 0 9.9 4.4 9.9 9.8v31.8c0 5.6-7.2 8-10.7 3.6L36 31.3v16.9c0 4.8-4 8.8-9 8.8H9.9C4.4 57 0 52.6 0 47.2zm9.9-2c-1.1 0-2 .9-2 2v37.3c0 1.1.9 2 2 2h17.4c.6 0 .7-.5.7-1V25.6c0-5.7 7.2-8.1 10.7-3.7l10.8 13.9v-26c0-1.1.1-2-1-2z",
    style: {
      fill: "url(#neon_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 9.8C0 4.4 4.4 0 9.9 0h37.7c5.4 0 9.9 4.4 9.9 9.8v31.8c0 5.6-7.2 8-10.7 3.6L36 31.3v16.9c0 4.8-4 8.8-9 8.8H9.9C4.4 57 0 52.6 0 47.2zm9.9-2c-1.1 0-2 .9-2 2v37.3c0 1.1.9 2 2 2h17.4c.6 0 .7-.5.7-1V25.6c0-5.7 7.2-8.1 10.7-3.7l10.8 13.9v-26c0-1.1.1-2-1-2z",
    style: {
      opacity: 0.3,
      fill: "url(#neon_svg__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6 0c5.4 0 9.9 4.4 9.9 9.8v31.8c0 5.6-7.2 8-10.7 3.6L36 31.3v16.9c0 4.8-4 8.8-9 8.8.6 0 1-.4 1-1V25.6c0-5.6 7.2-8 10.7-3.6l10.8 13.9V2c0-1.1-.9-2-1.9-2",
    style: {
      fill: "#63f655"
    }
  }));
};
export default SvgNeon;